import { render } from "./SecurityCaptchaView.vue?vue&type=template&id=9f188f10&scoped=true"
import script from "./SecurityCaptchaView.vue?vue&type=script&lang=js"
export * from "./SecurityCaptchaView.vue?vue&type=script&lang=js"

import "./SecurityCaptchaView.vue?vue&type=style&index=0&id=9f188f10&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f188f10"]])

export default __exports__